@if (isImmosucheAdminActive) {
<div class="kf-container">
  <h2 class="kf-headline-headline">{{'OEKOSYSTEM_IMMOSUCHE_TITEL' | translate}}</h2>
  <iframe
    [src]="url"
    [title]="'Immosuche'"
    referrerpolicy="no-referrer"
    allow="web-share"
    data-automation-id="iframe-container"
    #immosucheIframe
  ></iframe>
</div>
}
